<template>
    <div :class="classes.wrapper">
        <label class="label" @click="setFocus">{{ label }}</label>
        <input
            class="input"
            ref="input"
            type="text"
            :value="value"
            @change="$emit('input', $event.target.value)"
            @blur="onBlur"
            @focus="onFocus"
        />
        <div class="message" v-if="!isValid">Ce champ est obligatoire ou invalide</div>
    </div>
</template>
<script>

export default {
    name: "InputText",
    props: {
        label: { type: String, required: () => true },
        name: { type: String, required: () => true },
        type: { type: String, required: () => true },
        value: { type: String, default: "" },
        error: { type: String, required: () => true}
    },
    data() {
        return {
            isFocus: !!this.value,
            isValid: true,
            message: ""
        }
    },
    computed: {
        classes() {
            return {
                wrapper: ["control", {
                    error: !this.isValid,
                    focus: this.isFocus,
                    fill: this.isFilled
                }]
            }
        },
        isFilled() {
            return !!this.value;
        }
    },
    watch: {
        error: {
            handler: "onError",
            deep: true
        },
        value(val) {
            if(val !== "") {
                this.isFocus = true;
            }
        }
    },
    methods: {
        onBlur() {
            this.isFocus = this.isFilled;
        },
        onError(error) {
          this.isValid = !error;
        },
        onFocus() {
            this.isFocus = true;
        },
        setFocus() {
            const {input} = this.$refs;
            input.focus();
        },
        validateBeforeSubmit() {
            this.$refs.recaptcha.execute();
        },
        onCaptchaVerified(recaptchaToken) {
            const self = this;
            self.$refs.recaptcha.reset();
            if (!self.formData.acceptance) {
                self.formData.acceptanceText = "";
            }
            self.loading = true;
            // TODO PUT "/"
            axios.post("/webservice.php", {
                recaptchaToken: recaptchaToken,
                ...self.formData
            })
                .then(response => {
                    self.loading = false;
                    if ( response.data.status === "success" ) {
                        self.sucessfulServerResponse = response.data.message;
                        self.formSend = true;
                        this.updateDataLayer();
                    } else {
                        self.error = true;
                    }
                })
                .catch((err) => {
                    self.serverError = getErrorMessage(err);
                    function getErrorMessage(err) {
                        let responseBody;
                        responseBody = err.response;
                        if (!responseBody) {
                            responseBody = err;
                        } else {
                            responseBody = err.response.data || responseBody;
                        }
                        return responseBody.message || JSON.stringify(responseBody);
                    }
                })
                .then(() => {
                    self.status = "";
                });
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        updateDataLayer() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'declenche-evenement',
                'eventCategory': 'formulaire',
                'eventAction': 'submit'
            });
        }
    }
}
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import InputText
</style>
